module.exports = __webpack_public_path__ + "static/media/31.e6dd5de5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/31.jpg
// module id = 400
// module chunks = 0